import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  praDataService,
  riskSharedModelService,
  assetSharedModelService,
  praSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';
import assetsByType from 'app/components/admin/assetAdministration/assetsByType';
import editAssetDialog from 'app/components/admin/assetAdministration/dialog.editAssetDialog';
import controller from './assign-asset-dialog.controller';
import template from './assign-asset-dialog.html';
import nameMessagesTpl from './name.messages.html';

export class dialogService {
  getOptions($event, {
    process,
    assetTypes,
    assignedAssets,
  }) {
    return {
      controller,
      controllerAs: 'assignAssetDialogVM',
      locals: {
        process,
        assetTypes,
        assignedAssets
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.pra.assignAssetDialog', [
  ssDialogService,
  loaderService,
  praDataService,
  riskSharedModelService,
  assetSharedModelService,
  editAssetDialog,
  copy,
  alerts,
  assetsByType,
  praSharedModelService
])
  .service('assignPRAAssetDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.admin.pra.assignAssetDialog created');
